export enum ReportConfigurationLevel {
    NONE = 'NONE',
    ORGANIZATION = 'ORGANIZATION',
    DOMAIN = 'DOMAIN',
    NOTIFICATION = 'NOTIFICATION',
    TEST = 'TEST',
    CAMPAIGN = 'CAMPAIGN',
    SEGMENT = 'SEGMENT',
    KEYWORD = 'KEYWORD',
    PROMPT = 'PROMPT',
    APP_MESSAGE = 'APP_MESSAGE',
    ACTIVITY = 'ACTIVITY',
}
